import { render, staticRenderFns } from "./goodsPage.vue?vue&type=template&id=8b48609e&scoped=true&"
import script from "./goodsPage.vue?vue&type=script&lang=js&"
export * from "./goodsPage.vue?vue&type=script&lang=js&"
import style0 from "./goodsPage.vue?vue&type=style&index=0&id=8b48609e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b48609e",
  null
  
)

export default component.exports